import React from 'react'
import { ListingWireInstruction } from '@adc/sdk/types'
import { Text } from '../../../elementals'
import { ColorNames } from '../../../../constants'
import WireInstructions, { WireInstructionField } from '..'
import { CardContainerProps } from '../../../..'

interface RemoteBidWireInstructionsProps {
  wireInstruction: ListingWireInstruction
  bidderId: string
  cardContainerProps?: CardContainerProps
}

const RemoteBidWireInstructions = ({
  wireInstruction,
  bidderId,
  cardContainerProps,
}: RemoteBidWireInstructionsProps) => {
  return (
    <WireInstructions
      wireInstruction={wireInstruction}
      slots={{
        header: () => (
          <Text className='u-mt-1 u-mb-2' color={ColorNames.Gray}>
            To fund your account, wire funds from your bank to your Auction.com
            account. Please be prepared to provide the information below to
            complete your transfer, including your Bidder ID for reference or
            description.
          </Text>
        ),
        before: () => (
          <WireInstructionField
            label='Your Bidder ID'
            value={bidderId}
            elmId='wire_instructions_bidder_id'
          />
        ),
        after: () =>
          wireInstruction.escrow_address ? (
            <WireInstructionField
              label='Beneficiary Address'
              value={`${wireInstruction.escrow_address.street_description}, ${wireInstruction.escrow_address.municipality}, ${wireInstruction.escrow_address.country_primary_subdivision} ${wireInstruction.escrow_address.postal_code}`}
              elmId='wire_instructions_beneficiary_address'
            />
          ) : null,
      }}
      cardContainerProps={cardContainerProps}
    />
  )
}

export default RemoteBidWireInstructions
